import { Form, Input, Select } from 'antd';
import React from 'react';
import { EditableCellProps } from '../../model/CNDNModel';

//TODO: Need to implement multiple edit
const EditableCell: React.FC<EditableCellProps> = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  validation,
  maxLength,
  required,
  dropdownList,
  vatList,  
  allowClear,
  ...restProps
}) => {
  let validationRules;
  if (dataIndex === "remarks") {
    validationRules = [
      ({ getFieldValue }) => ({
          validator(_, value) {
              const trimmedValue = value?.trim();
          let amendVatPercentage;
          if (getFieldValue("cnNoteReasonId") !== undefined && getFieldValue("cnNoteReasonId") !== '') {
            amendVatPercentage = vatList?.find((el) => el?.id === getFieldValue("cnNoteReasonId"))?.vatPercentage;
          }
          else {
            amendVatPercentage = vatList?.find((el) => el?.id === getFieldValue("amendVatPercentageId"))?.vatPercentage;
          }
              if (!trimmedValue && record?.vatPercentage !== amendVatPercentage) {
                  return Promise.reject(new Error('Remarks is required for different percentages of VAT and Amend VAT'));
              }
              return Promise.resolve();
          },
      }),
    ];
  } else {
    validationRules = validation;
  }

  // let initialValue;
  // if (dataIndex === "amendVatPercentageId") {
  //   initialValue = dropdownList?.find((item) => item?.vatPercentage === record?.vatPercentage)?.id;
  // }

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item 
          required={required}
          name={dataIndex}
          style={{ margin: 0 }}
          rules={validationRules}
          // initialValue={initialValue}
        >
          {inputType === "select" ? 
            <Select allowClear={allowClear}>
              {
                dropdownList?.map((item) => (
                    <React.Fragment key={item?.id}>
                        <Select.Option key={item?.id} value={item?.id} >{item?.value}</Select.Option>
                    </React.Fragment>
                ))
              }
            </Select> :
            <Input placeholder={title} maxLength={maxLength} />}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

export default EditableCell